﻿import { ResultatValg, SET_VISNING, ResultatActionTypes } from './Types';
import { ValgStateActionTypes } from '../Valg/Types';

const initialState: ResultatValg = {
    visBoksB: false,
    visResultatKanFa: false,
    visResultatKanFaLangReisevei: false,
    visResultatKanKanskjeFa: false,
    visGenerellFeil: false,
};

export function resultatReducer(
    state: ResultatValg = initialState,
    action: ValgStateActionTypes | ResultatActionTypes,
): ResultatValg {
    switch (action.type) {
        case SET_VISNING: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
}
